import React, { useState } from "react";
import Image from "next/image";

export default function Team_Home_Layout3({ data }: { data: any }) {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  return (
    <section className="py-16 bg-[#F9F7F3]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl   text-center mb-12">{data.title}</h2>
        <div className="space-y-4">
          {data.founders.map((founder: any) => (
            <div key={founder.id} className="bg-white rounded-lg shadow-sm overflow-hidden">
              <button
                className="w-full flex items-center justify-between p-6 text-left"
                onClick={() => setExpandedId(expandedId === founder.id ? null : founder.id)}
              >
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 relative rounded-full overflow-hidden">
                    <Image
                      src={founder.picture.data.attributes.url}
                      alt={founder.name}
                      fill
                      className="object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="text-lg  ">{founder.name}</h3>
                    <p className="text-sm text-[#5A534A]">{founder.designation}</p>
                  </div>
                </div>
                <span className="text-2xl">
                  {expandedId === founder.id ? '−' : '+'}
                </span>
              </button>
              {expandedId === founder.id && (
                <div className="px-6 pb-6 pt-2 border-t border-[#EAE5DC]">
                  <p className="text-[#5A534A]">{founder.about}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}